<!-- RatesTierHelp.vue — "?" after "High-income country rates", as on #register's first step
     (fullstack Register/RatesTierHelp.vue): explains Regional Rates in the standard "?" popup
     (App/HelpPopup.vue). -->

<template>
  <AppHelpPopup id="regionalRatesHelp" label="About regional rates">
    <!-- the text and World Bank link are shared with #register's tooltip: fullstack
         public/events/regional-rates-help.json (/events is proxied/rewritten to fullstack) -->
    <span class="helpParagraph">{{ help?.intro }}</span>
    <span class="helpParagraph">
      If you’re not based in {{ tierParts.article }}
      <!-- the World Bank: another site, so a new tab (CLAUDE.md § Navigation) -->
      <a
        v-if="help?.incomeLevelsUrl"
        :href="help.incomeLevelsUrl"
        target="_blank"
        rel="noopener noreferrer"
      >{{ tierParts.phrase }}</a
      ><template v-else>{{ tierParts.phrase }}</template>,
      <router-link to="/2026/Contact">contact us</router-link>.
    </span>
  </AppHelpPopup>
</template>

<script setup>
import {computed, ref} from "vue";
import AppHelpPopup from "@/components/App/HelpPopup.vue";

const props = defineProps({tierPhrase: {type: String, default: "a high-income country"}});

// the shared tooltip text and the World Bank's country income levels (which the tiers follow)
const help = ref(null);
async function fetchHelp() {
  try {
    const response = await fetch("/events/regional-rates-help.json");
    if (response.ok) help.value = await response.json();
  } catch (error) {
    console.error(`RatesTierHelp: ${error}`);
  }
}
fetchHelp();

// "a high-income country" → {article: "a", phrase: "high-income country"}: the link is the phrase
const tierParts = computed(() => {
  const match = props.tierPhrase.match(/^(an?)\s+(.*)$/);
  if (!match) return {article: "", phrase: props.tierPhrase};
  return {article: match[1], phrase: match[2]};
});
</script>
